import { render } from "./EditRequest5.vue?vue&type=template&id=f6001b3c"
import script from "./EditRequest5.vue?vue&type=script&lang=js"
export * from "./EditRequest5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__